import * as React from 'react';
import IVotePost, { TVotePost } from './IVotePost';
import CompaniesPageService from '@services/CompaniesPage.service';
import { EPost } from '../Post/IPost';

import * as style from './VotePostStyle.module.scss'

export default class VotePost extends React.Component<IVotePost, TVotePost> {
  state = { votes: this.props.totalVotes, voted: this.props.userVote, disabled: false };

  componentDidUpdate(prevProps: IVotePost) {
    if (this.props.totalVotes !== prevProps.totalVotes || this.props.userVote !== prevProps.userVote) {
      this.setState({ votes: this.props.totalVotes, voted: this.props.userVote });
    }
  }

  displayVotes = () => {
    const votes = this.state.votes;
    if (votes >= 0) {
      return <p className={[style.votes, style.votesPlus].join(' ')}>{votes === 0 ? null : '+'}{votes}</p>;
    }

    return <p className={[style.votes, style.votesMinus].join(' ')}>{votes}</p>;
  }

  displayButtons = () => {
    const voted = this.state.voted;

    if (voted === EPost.up) {
      return (
        <React.Fragment>
          <button
            onClick={() => { this.voteRemove('up'); }}
            disabled={this.state.disabled}
            className={[style.plus, style.plusVoted].join(' ')}
          >
            <span className="fa fa-plus"/>
          </button>
          <button
            onClick={() => { this.voteUpdate('down'); }}
            disabled={this.state.disabled}
            className={style.minus}
          >
            <span className="fa fa-minus"/>
          </button>
        </React.Fragment>
      );
    }

    if (voted === EPost.down) {
      return (
        <React.Fragment>
          <button
            onClick={() => { this.voteUpdate('up'); }}
            disabled={this.state.disabled}
            className={style.plus}
          >
            <span className="fa fa-plus"/>
          </button>
          <button
            onClick={() => { this.voteRemove('down'); }}
            disabled={this.state.disabled}
            className={[style.minus, style.minusVoted].join(' ')}
          >
            <span className="fa fa-minus"/>
          </button>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <button
          onClick={() => { this.votePost('up'); }}
          disabled={this.state.disabled}
          className={style.plus}
        >
          <span className="fa fa-plus"/>
        </button>
        <button
          onClick={() => { this.votePost('down'); }}
          disabled={this.state.disabled}
          className={style.minus}
        >
          <span className="fa fa-minus"/>
        </button>
      </React.Fragment>
    );
  }

  votePost = (vote: string) => {
    this.setState({ disabled: true });

    CompaniesPageService.votePost(this.props.postId, vote)
      .then((res) => {
        if (vote === 'up') {
          this.setState({ voted: EPost.up, votes: this.state.votes + 1, disabled: false });
        } else {
          this.setState({ voted: EPost.down, votes: this.state.votes - 1, disabled: false });
        }
      });
  }

  voteUpdate = (vote: string) => {
    this.setState({ disabled: true });

    CompaniesPageService.votePost(this.props.postId, vote, false, true)
      .then((res) => {
        if (vote === 'up') {
          this.setState({ voted: EPost.up, votes: this.state.votes + 2, disabled: false });
        } else {
          this.setState({ voted: EPost.down, votes: this.state.votes - 2, disabled: false });
        }
      });
  }

  voteRemove = (vote: string) => {
    this.setState({ disabled: true });

    CompaniesPageService.votePost(this.props.postId, '', true)
      .then((res) => {
        if (res.status === 204) {
          this.setState({
            voted: null,
            votes: vote === 'up' ? this.state.votes - 1 : this.state.votes + 1,
            disabled: false,
          });
        }
      });
  }

  render() {
    return (
      <div className={style.votePost}>
        {this.displayVotes()}
        {this.displayButtons()}
      </div>
    );
  }
}
